import MultiSelectDropdown, {
  MultiSelectDropdownProps,
} from '../../../../components/shared/filters/multi-select-dropdown/MultiSelectDropdown';
type OptOutPreferenceDropdownProps = Pick<
  MultiSelectDropdownProps,
  | 'onOpen'
  | 'onClose'
  | 'options'
  | 'values'
  | 'onChange'
  | 'onUpdate'
  | 'selectionToggleType'
  | 'cssClass'
>;

export const optOutPreferenceDropdownDataTestId = 'opt-out-preference-dropdown';

const OptOutPreferenceDropdown = ({ ...props }: OptOutPreferenceDropdownProps) => (
  <MultiSelectDropdown
    {...props}
    dataTestId={optOutPreferenceDropdownDataTestId}
    placeholder='Opt-out Preference'
    displaySelectedLabels
    selectedLabelPosition='right'
    type='am-dropdown'
    enableCheckAll
  />
);

export default OptOutPreferenceDropdown;
